<template>
	<v-card outlined>
		<v-stepper v-model="e1" class="elevation-0">
			<my-toolbar :height="55" :title="tabTitle">
				<template v-slot:right-controls>
					<span class="subtitle-1 mr-3">Invoice Type: {{ getParseResults.invoiceType }}</span>
				</template>
			</my-toolbar>
			<v-stepper-items>

				<!-- PARSED RESULT COMPONENT -->
				<v-stepper-content step="1">
					<v-card outlined>
						<v-toolbar flat :height="40" color="grey lighten-5">
							<v-tabs v-model="uploadResultTab" slider-color="primary">
								<v-tab href="#invoice-header-tab" >Invoice Header</v-tab>
								<v-tab href="#invoice-items-tab" >Invoice Items</v-tab>
							</v-tabs>

							<v-btn v-if="uploadResultTab === 'invoice-header-tab'" depressed small color="warning" class="mr-1" @click.stop="visibleEditHeaderModal = true">
								Edit Invoice Header
							</v-btn>

							<v-btn v-if="uploadResultTab === 'invoice-items-tab'" depressed small color="warning" class="mr-1" @click="$refs.applyDiscountDialog.handleDialog">
								Apply Discount
							</v-btn>

							<v-btn depressed small color="primary"
								@click="downloadFile(getParseResults.insertToDb[1].file_name, getParseResults.insertToDb[2].file_link)"
							>Download Parsed Result</v-btn>
						</v-toolbar>

						<v-divider></v-divider>

						<v-tabs-items v-model="uploadResultTab">
							<v-tab-item value="invoice-header-tab">
								<UploadResultHeader :items="parsedResultInvoiceHeader" />
							</v-tab-item>
							<v-tab-item value="invoice-items-tab">
								<UploadResultTable :headers="parsedResultsTableHeader" />
							</v-tab-item>
						</v-tabs-items>
					</v-card>
		
					<v-row class="mt-3 mx-1">
						<v-btn color="error" to="/upload-list" class="mr-1" :disabled="disableValidateButton">Cancel</v-btn>
						<v-spacer></v-spacer>
						<v-btn v-if="getParseResults.invoiceType === 'MFN'" color="primary" class="px-5" @click="validateMFN" :loading="disableValidateButton" :disabled="disableValidateButton">Validate</v-btn>
						<v-btn v-if="getParseResults.invoiceType === 'BULK'" color="primary" class="px-5" @click="handleNavigation(2, 'Upload DD File')">Next</v-btn>
					</v-row>
				</v-stepper-content>

				<!-- DD UPLOAD COMPONENT (For DD Only) -->
				<v-stepper-content step="2">
					<v-row class="mx-2">
						<v-file-input
							v-model="files"
							accept=".xlsx"
							label="Upload File (.xlsx format)"
							:show-size="true"
							:loading="uploadDDLoading"
							@change="uploadDDTemplate"
						></v-file-input>
					</v-row>

					<v-row class="mx-1">
						<v-btn depressed color="primary"
								@click="downloadFile('dd_po_template.xlsx','https://invoice-audit.s3.amazonaws.com/templates/dd_po_template.xlsx')"
						>Download DD PO Template</v-btn>
						<v-spacer></v-spacer>
						<v-btn outlined color="primary" @click="handleNavigation(1, 'Parsed Results')" class="mr-1" :disabled="uploadDDLoading">Back</v-btn>
						<v-btn color="primary" class="px-5" @click="validateBULK" :disabled="uploadDDButton">Validate</v-btn>
					</v-row>
				</v-stepper-content>

				<!-- Validated Result Component -->
				<v-stepper-content step="3">
					<v-card outlined>
						<v-toolbar flat :height="50" color="grey lighten-5">
							<v-tabs v-model="validateResultTab" slider-color="primary">
								<v-tab
									href="#validate-tab"
									id="validatedTab"
									>Validated</v-tab>
								<v-tab
									href="#validate-duplicate-tab"
									id="duplicateTab"
									>Duplicates</v-tab>
							</v-tabs>
							<div class="mr-2">
								<v-text-field
									class="white"
									label="Search"
									single-line
									hide-details
									outlined
									clearable
									dense
									v-model="validateTableSearch"
								></v-text-field>
							</div>
							<v-switch style="white-space: nowrap;" class="mt-5" v-model="singleExpand" label="Multiple Expand"></v-switch>
						</v-toolbar>
						<v-divider></v-divider>
						<v-tabs-items v-model="validateResultTab">
							<v-tab-item value="validate-tab">
								<ValidatedTable :search="validateTableSearch" :items="getValidatedParsedResults" :headers="validatedTableHeader" :loading="tableLoading" :singleExpand="singleExpand" />
							</v-tab-item>
							<v-tab-item value="validate-duplicate-tab">
								<ValidatedDuplicateTable :items="getDuplicateParsedResults" :headers="validatedDuplicateTableHeader" :loading="tableLoading" :singleExpand="singleExpand" />
							</v-tab-item>
						</v-tabs-items>
					</v-card>

					<v-row class="mt-3 mx-1">
						<v-btn color="error" to="/upload-list" class="mr-1" :disabled="disableAddToRecordsButton">Cancel</v-btn>
						<v-spacer></v-spacer>
						<v-btn outlined depressed color="primary" @click="getParseResults.invoiceType === 'BULK' ? e1 = 2 : e1 = 1" :disabled="disableAddToRecordsButton">Back</v-btn>
						<v-btn color="success" class="px-5 ml-1" @click="addToRecords" :disabled="disableAddToRecordsButton" :loading="disableAddToRecordsButton">Add to Records</v-btn>
					</v-row>
				</v-stepper-content>
			</v-stepper-items>
		</v-stepper>
		<UploadResultHeaderModal :visibleEditHeaderModal="visibleEditHeaderModal" @close="visibleEditHeaderModal = false" />
		<UploadResultApplyDiscount ref="applyDiscountDialog" />
		<AddStatus />
	</v-card>
</template>

<script>
import axios from 'axios'

import UploadResultTable from './components/UploadResultTable';
import UploadResultHeader from './components/UploadResultHeader';
import UploadResultApplyDiscount from './components/UploadResultApplyDiscount';
import UploadResultHeaderModal from './components/UploadResultHeaderModal';
import ValidatedTable from './components/ValidatedTable';
import ValidatedDuplicateTable from './components/ValidatedDuplicateTable';
import AddStatus from './components/AddStatus';

import downloadFile from '@/services/downloadFileSvc';
import { validateDDInvoice, validateDuplicateDDInvoice } from '../../services/validateDDInvoiceSvc';
import { updateStoredListStatus } from '@/services/fileHandlerSvc'
import { state, getters } from '@/store/store'; 

export default {
	components: { UploadResultTable, UploadResultHeader, UploadResultHeaderModal, ValidatedTable, ValidatedDuplicateTable, UploadResultApplyDiscount, AddStatus },
	data: () => ({
		e1: 1,
		tabTitle: 'Parsed Results',
		uploadResultTab: 'invoice-header-tab',
		validateResultTab: 'validate-tab',
		singleExpand: false, //state for row expand in two table [validated table & validated duplicate table]
		tableLoading: false, //state for table loading in two table [validated table & validated duplicate table]
		disableValidateButton: false, //state for validate button when clicked
		disableAddToRecordsButton: false, //state for add to record button when clicked
		visibleEditHeaderModal: false, //state for edit header modal
		validateTableSearch: '',

		files: [], //storage for uploaded files
		uploadDDLoading: false, //loading for DD upload component
		uploadDDButton: true,
		uploadDDFilename: '',

		parsedResultsTableItems: [],
		parsedResultInvoiceHeader: null,
		parsedResultsTableHeader: [
			{ text: 'Item Number', value: 'itemNumber', sortable: true, width: '150px' },
			{ text: 'Ordered Qty', value: 'orderedQty', sortable: true },
			{ text: 'Out. Qty', value: 'outStandingQty', sortable: true },
			{ text: 'Shipped Qty', value: 'shippedQty', sortable: true },
			{ text: 'Item Cost', value: 'itemCost', sortable: true },
			{ text: 'Disc. Percentage', value: 'discountedPercentage', sortable: true },
			{ text: 'Disc. Cost', value: 'discountedPrice', sortable: true },
			{ text: 'Total Disc. Price', value: 'totalDiscountedPrice', sortable: true },
			{ text: 'Total Price', value: 'totalPrice', sortable: true },
			{ text: 'Action', value: 'action' }
		],
		validatedTableHeader: [
			{ text: '', value: 'data-table-expand' },

			{ text: 'DD SKU', value: 'ddSKU', sortable: true, width: '150px' },
			{ text: 'DD Cost', value: 'ddCost', sortable: true },
			{ text: 'DD Qty', value: 'ddQty', sortable: true },

			{ text: 'SKU Status', value: 'skuStatus', sortable: true, width: '80px' },
			{ text: 'Cost Status', value: 'costStatus', sortable: true, width: '80px' },
			{ text: 'Qty Status', value: 'qtyStatus', sortable: true, width: '80px' },

			{ text: 'SKU', value: 'sku', sortable: true, width: '150px' },
			{ text: 'Item Number', value: 'itemNumber', sortable: true, width: '150px' },
			{ text: 'BT Cost', value: 'btCost', sortable: true, width: '100px' },
			{ text: 'Ordered Qty', value: 'orderedQty', sortable: true },
			{ text: 'Shipped Qty', value: 'shippedQty', sortable: true },
			{ text: 'Item Cost', value: 'itemCost', sortable: true },
			{ text: 'Disc. Price', value: 'discountedPrice', sortable: true },
			{ text: 'Disc. Percentage', value: 'discountedPercentage', sortable: true },
			{ text: 'Total Disc. Price', value: 'totalDiscountedPrice', sortable: true },
			{ text: 'Total Price', value: 'totalPrice', sortable: true },
			{ text: 'Status', value: 'status', sortable: true }
		],
		validatedDuplicateTableHeader: [
			{ text: '', value: 'data-table-expand' },

			{ text: 'DD SKU', value: 'ddSKU', sortable: true, width: '150px' },
			{ text: 'DD Cost', value: 'ddCost', sortable: true },
			{ text: 'DD Qty', value: 'ddQty', sortable: true },

			{ text: 'SKU Status', value: 'skuStatus', sortable: true, width: '80px' },
			{ text: 'Cost Status', value: 'costStatus', sortable: true, width: '80px' },
			{ text: 'Qty Status', value: 'qtyStatus', sortable: true, width: '80px' },

			{ text: 'SKU', value: 'sku', sortable: true, width: '150px' },
			{ text: 'Item Number', value: 'itemNumber', sortable: true, width: '150px' },
			{ text: 'BT Cost', value: 'btCost', sortable: true, width: '100px' },
			{ text: 'Ordered Qty', value: 'orderedQty', sortable: true },
			{ text: 'Shipped Qty', value: 'shippedQty', sortable: true },
			{ text: 'Item Cost', value: 'itemCost', sortable: true },
			{ text: 'Disc. Price', value: 'discountedPrice', sortable: true },
			{ text: 'Disc. Percentage', value: 'discountedPercentage', sortable: true },
			{ text: 'Total Disc. Price', value: 'totalDiscountedPrice', sortable: true },
			{ text: 'Total Price', value: 'totalPrice', sortable: true },
			{ text: 'Action', value: 'action' }
		]
	}),
	methods: {
		downloadFile,
		validateDDInvoice,
		handleNavigation(step, title){
			this.e1 = step
			this.tabTitle = title
		},
		async uploadDDTemplate(){
			if(this.files){
				try {
					this.uploadDDLoading = true;
					let formData = new FormData();
					formData.append('myFile', this.files);
					let response = await this.$http.post('/file/upload', formData, {
						headers: {
							'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
						}
					});
					if (response.status == 200) {
						this.uploadDDFilename = response.data.filename
						this.uploadDDLoading = false;
						this.uploadDDButton = false;
						this.$toast.open({
							message: response.data.msg,
							type: 'success',
						});
					}
				} catch (error) {
					this.$toast.open({
						message: error.data,
						type: 'error',
					});
					this.uploadDDLoading = false;
					this.uploadDDButton = true;
				}
			}else{
				this.uploadDDButton = true;
			}
		},
		async validateBULK(){
			this.$Progress.start();
			this.uploadDDButton = true
			this.tableLoading = true
			state.validatedParsedResults = []
			state.duplicateParsedResults = []
			state.validatedHeader = null
			try {
				let response = await this.$http2.post('/check/data', JSON.stringify(this.getParseResults));
				
				//duplicate
				if(response.data.duplicateArray.length > 0){
					let duplicateItems = response.data.duplicateArray.map(e => {
						let isDiscounted = e.eachItem.discountedCost > 0 ? true : false;
						return {
							itemNumber: e.eachItem.itemNumber,
							upc: e.result.UPC,
							sku: e.result.SKU,
							asin: e.result.ASIN,
							description: e.result.description,
							oeStatus: e.result.OE_Status,
							btCost: e.itemBtCost,
							orderedQty: e.eachItem.orderedQty,
							shippedQty: e.eachItem.shippedQty,
							itemCost: e.eachItem.itemCost,
							discountedCost: e.eachItem.discountedCost,
							discountedPercentage: e.eachItem.discountedPercentage,
							totalPrice: e.eachItem.totalPrice,
							isDiscounted,
							status: 'duplicate'
						}
					})

					let response2 = await this.$http.post('/file/reader', JSON.stringify({
						typeOfRequest : "ddWorkbook",
						fileName : this.uploadDDFilename
					}))
					if(response2.status === 200){
						let ddResponse = response2.data.invoiceItem;
						let duplicateParsedItems = await this.validateDuplicateDDInvoice(duplicateItems, ddResponse);
						state.duplicateParsedResults = duplicateParsedItems
						this.validatedDuplicateTableHeader = this.validateHeader(this.validatedDuplicateTableHeader, duplicateParsedItems)
					}
				}

				// //non duplicate items
				if(response.data.noneDuplicateArray.length > 0){
					let validatedItems = response.data.noneDuplicateArray.map(e => {
						let isDiscounted = e.eachItem.discountedCost > 0 ? true : false;
						return {
							itemNumber: e.eachItem.itemNumber,
							upc: e.result.UPC,
							sku: e.result.SKU,
							asin: e.result.ASIN,
							description: e.result.description,
							oeStatus: e.result.OE_Status,
							btCost: e.itemBtCost,
							orderedQty: e.eachItem.orderedQty,
							shippedQty: e.eachItem.shippedQty,
							itemCost: e.eachItem.itemCost,
							discountedCost: e.eachItem.discountedCost,
							discountedPercentage: e.eachItem.discountedPercentage,
							totalPrice: e.eachItem.totalPrice,
							isDiscounted,
							status: 'good'
						}
					})

					let response2 = await this.$http.post('/file/reader', JSON.stringify({
						typeOfRequest : "ddWorkbook",
						fileName : this.uploadDDFilename
					}))
					
					if(response2.status === 200){
						let ddResponse = response2.data.invoiceItem;

						let validatedParsedItems = await this.validateDDInvoice(validatedItems, ddResponse);
						
						state.validatedParsedResults = validatedParsedItems
						this.validatedTableHeader = this.validateHeader(this.validatedTableHeader, validatedParsedItems)
					}
				}
				state.validatedHeader = this.getParseResults.invoiceInformation //always hold the updated invoice information header 

				this.uploadDDButton = false
				this.$Progress.finish();
				this.handleNavigation(3, "Validated Result & Approve")
				this.validateResultTab = 'validate-tab'
				this.tableLoading = false
			} catch (error) {
				this.$Progress.fail();
				this.uploadDDButton = false
				this.$toast.open({
					type: 'error',
					message: error
				})
			}
		},
		async validateMFN(){
			try {
				this.$Progress.start();
				this.tableLoading = true
				this.disableValidateButton = true
				state.validatedParsedResults = []
				state.duplicateParsedResults = []
				state.validatedHeader = null
				let response = await this.$http2.post('/check/data', JSON.stringify(this.getParseResults)); //used api from GCP

				// console.log(JSON.stringify(response.data, null, 2))
				//duplicate items
				if(response.data.duplicateArray){
					let duplicateItems = response.data.duplicateArray.map(e => {
						let isDiscounted = e.eachItem.discountedCost > 0 ? true : false;
						return {
							itemNumber: e.eachItem.itemNumber,
							upc: e.result.UPC,
							sku: e.result.SKU,
							asin: e.result.ASIN,
							description: e.result.description,
							btCost: e.itemBtCost,
							orderedQty: e.eachItem.orderedQty,
							shippedQty: e.eachItem.shippedQty,
							itemCost: e.eachItem.itemCost,
							discountedPrice: e.eachItem.discountedPrice,
							discountedPercentage: e.eachItem.discountedPercentage,
							totalDiscountedPrice: e.eachItem.totalDiscountedPrice,
							totalPrice: e.eachItem.totalPrice,
							isDiscounted,
							status: 'duplicate'
						}
					})
					state.duplicateParsedResults = duplicateItems
					this.validatedDuplicateTableHeader = this.validateHeader(this.validatedDuplicateTableHeader, duplicateItems)
				}
				//non duplicate items
				if(response.data.noneDuplicateArray){
					let validatedItems = response.data.noneDuplicateArray.map(e => {
						let isDiscounted = e.eachItem.discountedCost > 0 ? true : false;
						return {
							itemNumber: e.eachItem.itemNumber,
							upc: e.result.UPC,
							sku: e.result.SKU,
							asin: e.result.ASIN,
							description: e.result.description,
							btCost: e.itemBtCost,
							orderedQty: e.eachItem.orderedQty,
							shippedQty: e.eachItem.shippedQty,
							itemCost: e.eachItem.itemCost,
							discountedPrice: e.eachItem.discountedPrice,
							discountedPercentage: e.eachItem.discountedPercentage,
							totalDiscountedPrice: e.eachItem.totalDiscountedPrice,
							totalPrice: e.eachItem.totalPrice,
							isDiscounted,
							status: 'good'
						}
					})
					state.validatedParsedResults = validatedItems
					this.validatedTableHeader = this.validateHeader(this.validatedTableHeader, validatedItems)
				}
				state.validatedHeader = this.getParseResults.invoiceInformation //always hold the updated invoice information header 

				this.$Progress.finish();
				this.handleNavigation(3, "Validated Result & Approve")
				this.validateResultTab = 'validate-tab'
				this.tableLoading = false
				this.disableValidateButton = false
			} catch (error) {
				this.$Progress.fail();
				this.$toast.open({
					type: 'error',
					message: error.data.err.msg
				})
				this.disableValidateButton = false
			}
		},
		//SAVE TO RECORD FUNCTIONALITY
		async addToRecords(){
			
			this.$Progress.start();
			this.disableAddToRecordsButton = true
			let invoiceType = this.getParseResults.invoiceType
			let invoiceItems = this.getValidatedParsedResults.map(e => {
				return {
					...e,
					UPC: e.upc,
					ASIN: e.asin,
					SKU: e.sku,
					itemBtCost: e.btCost,
				}
			})
			
			
			let reqBody = {
				type: invoiceType,
				typeOfRequest: 'approved',
				invoiceType,
				invoiceInformation: [this.getParseResults.invoiceInformation],
				approvedItems: invoiceItems
			}

			let { invoiceNumber, poNumber } = this.getParseResults.invoiceInformation;
			let fileStatusId = this.getParseResults.insertToDb[0].id
			try {
				let response = await this.$http.post('/feed/invoice', JSON.stringify(reqBody));
				if(response.status === 200){
					await updateStoredListStatus(fileStatusId, 2)

					state.newlyAddedInvoiceNo = invoiceNumber
					state.newlyAddedPONo = poNumber

					this.$Progress.finish();
					this.disableAddToRecordsButton = false
					this.$router.push(`/invoice-records`)
				}
			} catch (error) {
				this.$Progress.fail();
				this.disableAddToRecordsButton = false
				
				if(error.data.err.msg.indexOf('505121')>-1){
					this.$toast.open({
						type: 'error',
						message: "Invoice Number already exist to records."
					})
				}else{
					this.$toast.open({
						type: 'error',
						message: error.data.err.msg
					})
				}
				
			}
		},
		validateHeader(headers, items){
			let modifiedHeader = headers;
			if(this.getParseResults.invoiceType === 'MFN'){
				modifiedHeader = headers.filter(header =>
					header.value !== 'ddSKU' && header.value !== 'ddCost' && header.value !== 'ddQty' &&
					header.value !== 'skuStatus' && header.value !== 'costStatus' && header.value !== 'qtyStatus'
				)
			}
			return modifiedHeader;
		},
		
	},
	computed:{
		...getters, //getParseResults, getValidatedParsedResults
	},
	created() {
		if(this.getParseResults.length === 0){
			this.$router.push('/upload-list');
		}else{
			this.parsedResultsTableItems = this.getParseResults.invoiceItem.map(item => {
				let itemCost = parseInt(item.itemCost) ? item.itemCost : 0;
				let discountedPrice = parseInt(item.discountedPrice) ? item.discountedPrice : 0;
				let discountedPercentage = parseInt(item.discountedPercentage) ? item.discountedPercentage : 0;
				let totalDiscountedPrice = parseInt(item.totalDiscountedPrice) ? item.totalDiscountedPrice : 0;
				let totalPrice = parseInt(item.totalPrice) ? item.totalPrice : 0;

				return {
					...item,
					itemCost,
					discountedPrice,
					discountedPercentage,
					totalDiscountedPrice,
					totalPrice
				}
			})
			this.parsedResultsTableHeader = this.validateHeader(this.parsedResultsTableHeader, this.getParseResults.invoiceItem)
			this.parsedResultInvoiceHeader = this.getParseResults.invoiceInformation
		}
	}
}
</script>

<style scoped>
#validatedTab{
	background-color: #4DAF51;
	color: #fff;
}

#duplicateTab{
	background-color: #E53935;
	color: #fff;
}
</style>